import React from "react";
import { motion } from "framer-motion";
import styles from "./InnerHero.module.css";

const renderBreadcrumbs = (breadcrumbs) => {
  if (!Array.isArray(breadcrumbs) || breadcrumbs.length === 0) return null;

  return (
    <div className={styles.breadcrumbs}>
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={index}>
            {item.href && !isLast ? (
              <a href={item.href} className={styles.breadcrumbLink}>
                {item.label}
              </a>
            ) : (
              <span className={styles.breadcrumbCurrent}>{item.label}</span>
            )}
            {!isLast && <span className={styles.breadcrumbDivider}>/</span>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const InnerHero = ({
  title,
  subtitle,
  backgroundImage,
  breadcrumbs,
  eyebrow,
  children,
}) => {
  return (
    <section className={styles.hero}>
      <div
        className={styles.background}
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        }}
      />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <motion.div
          className={styles.inner}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, ease: "easeOut" }}
        >
          {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
          {renderBreadcrumbs(breadcrumbs)}
          {title ? <h1 className={styles.title}>{title}</h1> : null}
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          {children ? <div className={styles.extra}>{children}</div> : null}
        </motion.div>
      </div>
    </section>
  );
};

export default InnerHero;
